module.exports = __webpack_public_path__ + "static/img/Logo-interSeguros-h.0421c8b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/Logo-interSeguros-h.webp
// module id = Ug0I
// module chunks = 0